export { EgisService } from './services/egis.service';
